import React, { useEffect, useState } from "react";
import {
  Card,
  Container,
  CardBody,
  CardSubtitle,
  CardTitle,
  CardText,
  Button,
  ModalBody,
  Modal,
  Form,
} from "reactstrap";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { Autocomplete } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { styled } from "@mui/system";
import { Input as BaseInput } from "@mui/base/Input";
import {
  pOPaymentList,
  genertePaymentList,
  getPendingPaymentsPoList,
} from "../../../api/po";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { StorePageHeaderName } from "../../../store/pageHeader/action";
import Grid from "@mui/material/Grid";

const blue = {
  100: "#DAECFF",
  200: "#b6daff",
  400: "#3399FF",
  500: "#007FFF",
  600: "#0072E5",
  900: "#003A75",
};

const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};

const InputElement = styled("input")(
  ({ theme }) => `
    width: 120px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 4px;
    color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
    background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
    border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
    box-shadow: 0px 2px 4px ${
      theme.palette.mode === "dark" ? "rgba(0,0,0, 0.5)" : "rgba(0,0,0, 0.05)"
    };

    &:hover {
      border-color: ${blue[400]};
    }

    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${
        theme.palette.mode === "dark" ? blue[600] : blue[200]
      };
    }

    // firefox
    &:focus-visible {
      outline: 0;
    }
  `
);
const PaymentPo = () => {
  // const [showList, setShowList] = useState(false);

  const dispatch = useDispatch();
  dispatch(StorePageHeaderName("PO Payment"));

  const [poDetails, setPoDetails] = useState({
    total_amount: null,
    remaining_amount: null,
    vendor_name: null,
    advance_amount: null,
    balance_amount: null,
  });
  const [gridLoad, setGridLoad] = useState(false);
  const [poList, setPoList] = useState([]);
  const initialState = {
    po_id: null,
    bank: null,
    payment_date: null,
    payment_ref_no: "",
    payment_type: null,
    amount: "",
    rate: "",
    func_amount: null,
  };
  const [pendingPoList, setPendingPoList] = useState([]);
  const [poValue, setPoValue] = useState(initialState);
  const [paymentRows, setPaymentRows] = useState([]);
  const [modalState, setModalState] = useState(false);

  const Input = React.forwardRef(function CustomInput(props, ref) {
    return <BaseInput slots={{ input: InputElement }} {...props} ref={ref} />;
  });
  document.title = "Dashboard | Procurement Dashboard";

  const bankOptions = [
    { label: "ICICI BANK", value: "ICICI BANK" },
    { label: "SBI", value: "SBI" },
    { label: "AXIS BANK", value: "AXIS BANK" },
    { label: "BANK OF BARODA", value: "BANK OF BARODA" },
  ];

  const paymentOptions = [
    { label: "CHEQUE", value: "CHEQUE" },
    { label: "NEFT", value: "NEFT" },
    { label: "BANK TRANSFER", value: "BANK TRANSFER" },
  ];

  const formik = useFormik({
    initialValues: initialState,
    enableReinitialize: true,
    validationSchema: Yup.object({
      po_id: Yup.string()
        .nullable(true)
        .required("Please Select Po Number")
        .oneOf(
          poList.map((option) => option.value),
          "Selected PO is not valid"
        ),
      bank: Yup.string()
        .nullable(true)
        .required("Please Select Your Bank")
        .oneOf(
          bankOptions.map((option) => option.value),
          "Selected bank is not valid"
        ),
      payment_date: Yup.date().required("Please Select Payment Date"),
      payment_ref_no: Yup.string().required("Please Enter Payment Ref No."),
      payment_type: Yup.string()
        .nullable(true)
        .required("Please Select Payment Type")
        .oneOf(
          paymentOptions.map((option) => option.value),
          "Selected Payment Option is not valid"
        ),
      amount: Yup.number()
        .required("Please Enter Amount")
        .when("po_id", {
          is: (po_id) => !!po_id,
          then: Yup.number().max(
            poDetails.remaining_amount,
            "Amount exceeds the maximum limit for the selected PO"
          ),
        }),
      rate: Yup.number().required("Please Enter Rate"),
    }),

    onSubmit: (values) => {
      toggleModal();
    },
  });

  const columns = [
    {
      field: "Sl_No",
      headerName: "Sl.No",
      flex: 0.5,
      resizable: false,
      sortable: false,
    },
    {
      field: "po_no",
      headerName: "Po No.",
      headerClassName: "table-header-background",
      // width: 160,
      editable: false,
      resizable: false,
      sortable: false,
      flex: 1,
      headerAlign: "center",
      cellClassName: "center-aligndata",
    },
    {
      field: "payment_date",
      headerName: "Date",
      headerClassName: "table-header-background",
      // width: 160,
      editable: false,
      resizable: false,
      sortable: false,
      flex: 1,
    },
    {
      field: "payment_no",
      headerName: "Payment Number",
      // headerClassName: 'break-header',
      // cellClassName: 'product_name_wrap',
      // width: 160,
      editable: false,
      resizable: false,
      sortable: false,
      flex: 1,
      headerAlign: "center",
      cellClassName: "center-aligndata",
    },
    {
      field: "bank",
      headerName: "Bank",
      headerClassName: "break-header",
      headerAlign: "center",
      cellClassName: "center-aligndata",
      // cellClassName: 'product_name_wrap',
      // width: 160,
      editable: false,
      resizable: false,
      sortable: false,
      flex: 1,
    },
    {
      field: "amount",
      headerName: "Amount",
      // headerClassName: 'break-header',
      // cellClassName: 'product_name_wrap',
      // width: 160,
      editable: false,
      resizable: false,
      sortable: false,
      flex: 1,
      headerAlign: "center",
      cellClassName: "center-aligndata",
    },
    {
      field: "rate",
      headerName: "Rate",
      // headerClassName: 'break-header',
      // cellClassName: 'product_name_wrap',
      // width: 160,
      editable: false,
      resizable: false,
      sortable: false,
      flex: 1,
      headerAlign: "center",
      cellClassName: "center-aligndata",
    },
    {
      field: "func_amount",
      headerName: "Func Amount",
      headerClassName: "table-header-background",
      // width: 160,
      editable: false,
      resizable: false,
      sortable: false,
      flex: 1,
      headerAlign: "center",
      cellClassName: "center-aligndata",
    },
    {
      field: "payment_no",
      headerName: "Payment No.",
      headerClassName: "table-header-background",
      // width: 160,
      editable: false,
      resizable: false,
      sortable: false,
      flex: 1,
      headerAlign: "center",
      cellClassName: "center-aligndata",
    },
  ];

  // const [inputValue, setInputValue] = useState('');
  // const [selectedValue, setSelectedValue] = useState(null);

  const searchPOPaymentHistory = async (payload = {}) => {
    try {
      setGridLoad(true);

      const res = await pOPaymentList(payload);

      const result = res.data.payments;
      if (res.statusCode === 200 && result.length > 0) {
        const formattedProducts = result.map((payment, index) => ({
          id: payment.id, // Assuming index + 1 as ID
          Sl_No: index + 1, // Serial Number
          po_no: payment?.procurementErpPODetails?.PONUMBER,
          payment_date: payment.payment_date,
          payment_ref_no: payment.payment_ref_no,
          bank: payment.bank,
          amount: payment.amount,
          rate: payment.rate,
          func_amount: payment.func_amount,
          payment_no: payment.payment_no,
        }));
        setPaymentRows(formattedProducts);
      } else {
        setPaymentRows([]);
      }
    } catch (error) {
      toast.error("Error in fetching approval list for purchase");
      console.log(error);
    } finally {
      setGridLoad(false);
    }
  };

  const getPOList = async (payload = {}) => {
    try {
      const res = await getPendingPaymentsPoList(payload);
      const result = res.data.pendingPoItems;
      if (res.statusCode === 200 && result.length > 0) {
        const formattedPOList = result.map((po) => ({
          label: po.PONUMBER,
          value: po.id,
        }));
        setPendingPoList(result);
        setPoList(formattedPOList);
      }
    } catch (error) {
      console.log(error);
      toast.error("Error in fetching PO List");
    }
  };

  useEffect(() => {
    getPOList();
  }, []);

  const getPODetails = async (payload = {}) => {
    const selectedPo = pendingPoList.filter(
      (element) => element.id == payload.po_id
    );
    setPoDetails({
      total_amount: selectedPo[0].total_amount,
      remaining_amount: selectedPo[0].remaining_amount,
      vendor_name: selectedPo[0].VDNAME,
      advance_amount: selectedPo[0].advance_amount,
      balance_amount: selectedPo[0].balance_amount,
    });
  };

  useEffect(() => {
    if (poValue.po_id) {
      getPODetails({ po_id: poValue.po_id.value });
      searchPOPaymentHistory({ po_id: poValue.po_id.value });
    } else {
      setPoDetails({
        total_amount: null,
        remaining_amount: null,
        vendor_name: null,
        advance_amount: null,
        balance_amount: null,
      });
    }
  }, [poValue.po_id]);

  const toggleModal = () => {
    setModalState((prev) => !prev);
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        ...formik.values,
        func_amount: formik.values.amount * formik.values.rate,
      };

      if (formik.values.payment_date) {
        payload.payment_date = dayjs(formik.values.payment_date).format(
          "YYYY-MM-DD"
        );
      }
      console.log("payload to be submitted", payload);
      await genertePaymentList(payload);
      toast.success("Payment List generated successfully");
      setPoValue(initialState);
      formik.resetForm();
      setPaymentRows([]);
      getPOList();
    } catch (error) {
      console.log(error);
      toast.error("Error in generating payment list");
    } finally {
      toggleModal();
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div>
            <Card>
              <CardBody>
                <div>
                  <Form onSubmit={formik.handleSubmit}>
                    <div className="d-flex align-items-center justify-content-between mb-2 gap-2">
                      <div className="d-flex align-items-center gap-2">
                        <p className="mb-0 me-2 requisition_type_text">
                          {/* Select Po No */}
                          Add Payment
                        </p>
                        <div>
                          <Autocomplete
                            className="invoice_autofield"
                            sx={{ width: 190 }}
                            options={poList}
                            name="po_id"
                            value={poValue.po_id}
                            onBlur={formik.handleBlur}
                            onChange={(_, value) => {
                              setPoValue((prev) => ({
                                ...prev,
                                po_id: value,
                              }));
                              formik.setFieldValue("po_id", value.value);
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Po No"
                                name="po_id"
                                error={
                                  formik.touched.po_id &&
                                  Boolean(formik.errors.po_id)
                                }
                                helperText={
                                  formik.touched.po_id && formik.errors.po_id
                                }
                              />
                            )}
                          />
                        </div>
                        <div className="d-flex gap-3">
                          {poDetails.vendor_name ||
                          poDetails.vendor_name === "" ? (
                            <>
                              <span className="ms-2">
                                <span
                                  style={{
                                    fontSize: "15px",
                                    fontWeight: "500",
                                    color: "#545B69",
                                  }}
                                >
                                  Vendor :
                                </span>
                                <span
                                  className="ms-1"
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                >
                                  {poDetails.vendor_name}
                                </span>
                              </span>
                              <div
                                style={{
                                  borderRight: "1px solid rgb(175 172 172)",
                                  height: "25px",
                                }}
                              ></div>
                            </>
                          ) : null}

                          {poDetails.total_amount ||
                          poDetails.total_amount == 0 ? (
                            <>
                              <span className="ms-2">
                                <span
                                  style={{
                                    fontSize: "15px",
                                    fontWeight: "500",
                                    color: "#545B69",
                                  }}
                                >
                                  Total Amount :
                                </span>
                                <span
                                  className="ms-1"
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "500",
                                  }}
                                >
                                  {poDetails.total_amount}
                                </span>
                              </span>
                              <div
                                style={{
                                  borderRight: "1px solid rgb(175 172 172)",
                                  height: "25px",
                                }}
                              ></div>
                            </>
                          ) : null}

                          {poDetails.remaining_amount ||
                          poDetails.remaining_amount == 0 ? (
                            <span>
                              <span
                                style={{
                                  fontSize: "15px",
                                  fontWeight: "500",
                                  color: "#545B69",
                                }}
                              >
                                Remaining Amount :
                              </span>
                              <span
                                className="ms-1"
                                style={{ fontSize: "14px", fontWeight: "500" }}
                              >
                                {poDetails.remaining_amount}
                              </span>
                            </span>
                          ) : null}

                          {poDetails.advance_amount ||
                          poDetails.advance_amount == 0 ? (
                            <span>
                              <span
                                style={{
                                  fontSize: "15px",
                                  fontWeight: "500",
                                  color: "#545B69",
                                }}
                              >
                                Advance Amount :
                              </span>
                              <span
                                className="ms-1"
                                style={{ fontSize: "14px", fontWeight: "500" }}
                              >
                                {poDetails.advance_amount}
                              </span>
                            </span>
                          ) : null}

                          {poDetails.balance_amount ||
                          poDetails.balance_amount == 0 ? (
                            <span>
                              <span
                                style={{
                                  fontSize: "15px",
                                  fontWeight: "500",
                                  color: "#545B69",
                                }}
                              >
                                Balance Amount :
                              </span>
                              <span
                                className="ms-1"
                                style={{ fontSize: "14px", fontWeight: "500" }}
                              >
                                {poDetails.balance_amount}
                              </span>
                            </span>
                          ) : null}
                        </div>
                      </div>
                    </div>
                    <div
                      className="p-3 mt-3"
                      style={{
                        backgroundColor: "#FAFDFF",
                        border: "1px solid #C3E8FF",
                        borderRadius: "5px",
                      }}
                    >
                      <div className="d-flex align-items-center mb-2 gap-3 flex-wrap">
                        <Grid container item xs={12} sm={12} spacing={1}>
                          <Grid item xs={4}>
                            {/* <div style={{ width: "calc(25% - 16px)" }}> */}
                            <Grid
                              container
                              item
                              xs={12}
                              sm={12}
                              spacing={1}
                              sx={{ alignItems: "center" }}
                            >
                              <Grid item xs={3}>
                                <p className="mb-0">Date</p>
                              </Grid>
                              <Grid item xs={9}>
                                <LocalizationProvider
                                  dateAdapter={AdapterDayjs}
                                >
                                  <DatePicker
                                    className="payment_date date_picker_fullwidth"
                                    label="PI Date"
                                    name="payment_date"
                                    onBlur={formik.handleBlur}
                                    value={formik.values.payment_date}
                                    onChange={(value) =>
                                      formik.setFieldValue(
                                        "payment_date",
                                        value
                                      )
                                    }
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        error={
                                          formik.touched.payment_date &&
                                          Boolean(formik.errors.payment_date)
                                        }
                                        helperText={
                                          formik.touched.payment_date &&
                                          formik.errors.payment_date
                                        }
                                      />
                                    )}
                                  />
                                </LocalizationProvider>
                              </Grid>
                            </Grid>
                            {/* </div> */}
                            {/* </div> */}
                          </Grid>
                          <Grid item xs={4}>
                            {/* <div style={{ width: "calc(25% - 16px)" }}> */}
                            {/* <div className="d-flex align-items-center gap-3"> */}
                            <Grid
                              container
                              item
                              xs={12}
                              sm={12}
                              spacing={1}
                              sx={{ alignItems: "center" }}
                            >
                              <Grid item xs={5}>
                                {/* <div style={{ width: "120px" }}> */}
                                <p className="mb-0">Payment Mode</p>
                                {/* </div> */}
                              </Grid>
                              <Grid item xs={7}>
                                <Autocomplete
                                  className="invoice_autofield"
                                  // sx={{ width: 205 }}
                                  sx={{ width: "100%" }}
                                  options={paymentOptions}
                                  name="payment_type"
                                  value={formik.values.payment_type}
                                  onBlur={formik.handleBlur}
                                  onChange={(_, value) =>
                                    formik.setFieldValue(
                                      "payment_type",
                                      value.value
                                    )
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Payment Type"
                                      name="payment_type"
                                      error={
                                        formik.touched.payment_type &&
                                        Boolean(formik.errors.payment_type)
                                      }
                                      helperText={
                                        formik.touched.payment_type &&
                                        formik.errors.payment_type
                                      }
                                    />
                                  )}
                                />
                              </Grid>
                              {/* </div> */}
                            </Grid>
                            {/* </div> */}
                          </Grid>
                          <Grid item xs={4}>
                            {/* <div style={{ width: "calc(25% - 16px)" }}> */}
                            {/* <div className="d-flex align-items-center gap-3">
                            <div style={{ width: "120px" }}> */}
                            <Grid
                              container
                              item
                              xs={12}
                              sm={12}
                              spacing={1}
                              sx={{ alignItems: "center" }}
                            >
                              <Grid item xs={5}>
                                <p className="mb-0 ms-3">Select Bank</p>
                                {/* </div> */}
                              </Grid>
                              <Grid item xs={7}>
                                <Autocomplete
                                  className="invoice_autofield"
                                  // sx={{ width: 205 }}
                                  sx={{ width: "100%" }}
                                  options={bankOptions}
                                  name="bank"
                                  onBlur={formik.handleBlur}
                                  value={formik.values.bank}
                                  onChange={(_, value) =>
                                    formik.setFieldValue("bank", value.value)
                                  }
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Select Bank"
                                      name="bank"
                                      error={
                                        formik.touched.bank &&
                                        Boolean(formik.errors.bank)
                                      }
                                      helperText={
                                        formik.touched.bank &&
                                        formik.errors.bank
                                      }
                                    />
                                  )}
                                />
                              </Grid>
                            </Grid>
                            {/* </div> */}
                            {/* </div> */}
                          </Grid>
                          <Grid item xs={3}>
                            {/* <div style={{ width: "calc(25% - 16px)" }}> */}
                            {/* <div className="d-flex align-items-center gap-3">
                            <div style={{ width: "55px" }}> */}
                            <Grid
                              container
                              item
                              xs={12}
                              sm={12}
                              spacing={1}
                              sx={{ alignItems: "center" }}
                            >
                              {/* <Grid item xs={3}>
                                <p className="mb-0">Ref. No.</p>
                              
                              </Grid>
                              <Grid item xs={9}>
                                <TextField
                                  className="invoice_field"
                                  label="Ref No"
                                  name="payment_ref_no"
                                  value={formik.values.payment_ref_no}
                                  onChange={(event) =>
                                    formik.setFieldValue(
                                      "payment_ref_no",
                                      event.target.value
                                    )
                                  }
                                  onBlur={formik.handleBlur}
                                  variant="outlined"
                                  // sx={{ width: 205 }}
                                  sx={{ width: "100%" }}
                                  error={
                                    formik.touched.payment_ref_no &&
                                    Boolean(formik.errors.payment_ref_no)
                                  }
                                  helperText={
                                    formik.touched.payment_ref_no &&
                                    formik.errors.payment_ref_no
                                  }
                                />
                              </Grid> */}
                            </Grid>
                            {/* </div> */}
                            {/* </div> */}
                          </Grid>
                        </Grid>
                      </div>

                      <div className="d-flex align-items-center mb-2 gap-3 flex-wrap mt-3">
                        <Grid container item xs={12} sm={12} spacing={1}>
                          <Grid item xs={4}>
                            {/* <div style={{ width: "calc(25% - 16px)" }}> */}
                            {/* <div className="d-flex align-items-center gap-3">
                            <div style={{ width: "55px" }}> */}
                            <Grid
                              container
                              item
                              xs={12}
                              sm={12}
                              spacing={1}
                              sx={{ alignItems: "center" }}
                            >
                              <Grid item xs={3}>
                                <p className="mb-0">Amount</p>
                                {/* </div> */}
                              </Grid>
                              <Grid item xs={9}>
                                <TextField
                                  className="create_requisition_textfield"
                                  label="Amount"
                                  name="amount"
                                  value={formik.values.amount}
                                  onChange={(event) => {
                                    if (
                                      event.target.value >= 0 &&
                                      event.target.value < 999999999
                                    ) {
                                      formik.setFieldValue(
                                        "amount",
                                        event.target.value
                                      );
                                    }
                                  }}
                                  variant="outlined"
                                  type="number"
                                  // sx={{ width: 205 }}
                                  sx={{ width: "100%" }}
                                  error={
                                    formik.touched.amount &&
                                    Boolean(formik.errors.amount)
                                  }
                                  helperText={
                                    formik.touched.amount &&
                                    formik.errors.amount
                                  }
                                />
                                {/* </div> */}
                              </Grid>
                            </Grid>
                          </Grid>
                          {/* </div> */}
                          <Grid item xs={4}>
                            {/* <div style={{ width: "calc(25% - 16px)" }}>
                          <div className="d-flex align-items-center gap-3">
                            <div style={{ width: "120px" }}> */}
                            <Grid
                              container
                              item
                              xs={12}
                              sm={12}
                              spacing={1}
                              sx={{ alignItems: "center" }}
                            >
                              <Grid item xs={5}>
                                <p className="mb-0">Rate</p>
                                {/* </div> */}
                              </Grid>
                              <Grid item xs={7}>
                                <TextField
                                  className="create_requisition_textfield"
                                  label="Rate"
                                  name="rate"
                                  value={formik.values.rate}
                                  onChange={(event) => {
                                    if (
                                      event.target.value >= 0 &&
                                      event.target.value < 999999999
                                    ) {
                                      formik.setFieldValue(
                                        "rate",
                                        event.target.value
                                      );
                                    }
                                  }}
                                  variant="outlined"
                                  type="number"
                                  // sx={{ width: 205 }}
                                  sx={{ width: "100%" }}
                                  error={
                                    formik.touched.rate &&
                                    Boolean(formik.errors.rate)
                                  }
                                  helperText={
                                    formik.touched.rate && formik.errors.rate
                                  }
                                />
                              </Grid>
                              {/* </div> */}
                            </Grid>
                          </Grid>
                          {/* </div> */}
                          <Grid item xs={4}>
                            {/* <div style={{ width: "calc(25% - 16px)" }}> */}
                            {/* <div className="d-flex align-items-center gap-3">
                            <div style={{ width: "120px" }}> */}
                            <Grid
                              container
                              item
                              xs={12}
                              sm={12}
                              spacing={1}
                              sx={{ alignItems: "center" }}
                            >
                              <Grid item xs={5}>
                                <p className="mb-0 ms-3">Func Amount</p>
                                {/* </div> */}
                              </Grid>
                              <Grid item xs={7}>
                                <TextField
                                  disabled={true}
                                  className="create_requisition_textfield"
                                  label="FuncAmount"
                                  value={
                                    formik.values.amount * formik.values.rate
                                  }
                                  variant="outlined"
                                  type="number"
                                  // sx={{ width: 205 }}
                                  sx={{ width: "100%" }}
                                />
                              </Grid>
                            </Grid>
                            {/* </div> */}
                            {/* </div> */}
                            {/* </div> */}
                          </Grid>
                        </Grid>
                      </div>
                    </div>
                  </Form>
                  <div className="d-flex align-items-center justify-content-end mt-3">
                      <button className="save_button" type="submit">
                        Submit
                  </button>
            </div>
                </div>
              </CardBody>
            </Card>
            <Modal isOpen={modalState} toggle={toggleModal}>
              <div className="d-flex justify-content-between me-2 mt-3">
                <h4 className="ms-3">Do You Want To Submit This Payment?</h4>
                <div className="d-flex justify-content-end me-3 modal_close">
                  <i className="ri-close-line" onClick={toggleModal}></i>
                </div>
              </div>
              <hr className="mb-2 mt-1 ms-3 me-3"></hr>
              <ModalBody className="pt-2">
                <div>
                  <table id="table" className="requisition_balance">
                    <thead className="booked_balance_listHeader">
                      <tr>
                        <th>Payment Mode</th>
                        <th>Bank</th>
                        <th>Amount</th>
                        <th>Rate</th>
                        <th>Func. Amount</th>
                      </tr>
                    </thead>

                    <tbody className="requisition_balance_table_body">
                      <tr>
                        <td>{formik.values.payment_type}</td>
                        <td>{formik.values.bank}</td>
                        <td>{formik.values.amount}</td>
                        <td>{formik.values.rate}</td>
                        <td>{formik.values.amount * formik.values.rate}</td>
                      </tr>
                    </tbody>
                    {/* <tfoot className='requisition_balance_footer'>
                                        <tr>
                                            <th id="total" colSpan="3">Total :</th>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.total_qty;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.received_qty;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.unit_price;
                                                }, 0)}</td>
                                            <td>{payload?.invoice_items.reduce((accumulator, currentObject) => {
                                                  return accumulator + (currentObject.unit_price * currentObject.received_qty * payload.conversion_rate);
                                                }, 0)}</td>
                                        </tr>
                                    </tfoot> */}
                  </table>
                </div>
                <hr className="mb-2 mt-1 ms-3 me-3"></hr>
                <div className="d-flex align-items-center mt-4 justify-content-center">
                  <button
                    className="yes_button d-flex align-items-center"
                    onClick={handleSubmit}
                  >
                    Yes
                  </button>
                  <button
                    className="no_button d-flex align-items-center ms-3"
                    onClick={toggleModal}
                  >
                    No
                  </button>
                </div>
              </ModalBody>
            </Modal>
            <div>
              <div>
                <h4 className="mb-0 requisition_text">All Payments</h4>
              </div>
              <Box
                sx={{
                  height: "100%",
                  width: "100%",
                  marginBottom: "1.5rem",
                  marginTop: "10px",
                }}
              >
                <DataGrid
                  autoHeight
                  className="table_header_background"
                  headerClassName="custom-header-cell"
                  getRowHeight={() => "auto"}
                  rows={paymentRows}
                  loading={gridLoad}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 5,
                      },
                    },
                  }}
                  pageSizeOptions={[5]}
                  disableRowSelectionOnClick
                  disableColumnMenu
                  disableColumnResize={true}
                  componentsProps={{
                    cell: {
                      disableClick: true,
                    },
                  }}
                  sx={{
                    "& .MuiDataGrid-cell": {
                      "& .MuiDataGrid-cell--textOverflow": {
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      },
                    },
                  }}
                />
              </Box>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PaymentPo;
